// src/app/sidenav/sidenav.service.ts

import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs'; // 1. Importar Observable
import { take } from 'rxjs/operators'; // 2. Importar 'take'
import { SidenavPages } from './sidenav.component';

interface SidenavEvent {
  page: SidenavPages;
  data: any;
}

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  private page = new Subject<SidenavEvent>();

  // 3. Adicionar um Subject para o evento de "fechar"
  private closed = new Subject<void>();

  pageChanges = this.page.asObservable();

  constructor() {}

  // 4. Modificar 'open' para retornar um Observable<void>
  open(page: SidenavPages, data?: any): Observable<void> {
    this.page.next({ page, data });

    // 5. Retornar um observable que 'escuta' o evento 'closed' apenas uma vez
    return this.closed.asObservable().pipe(take(1));
  }

  // 6. Adicionar método para o SidenavComponent notificar o fechamento
  notifyClosed() {
    this.closed.next();
  }
}
